import React from "react";
import { string, bool } from "prop-types";

import SerialStoriesTab from "../../../molecules/SerialStoriesTab";
import TagStorySearch from "../../../molecules/TagStorySearch";
import DfpAd from "../../../dfp-ad";

import { validURL } from "../../../utils/utils";

import "./organism3.m.css";

const Organism3 = ({
  className = "",
  isSectionComponent,
  widgetUrl = null,
  widgetHeight = null,
  collectionSlug,
  adSlotId = "",
  lang,
}) => {
  const collectionsNames = widgetUrl && widgetUrl.includes("latestnews") && widgetUrl.split(":")[1];

  return (
    <div styleName="base" className={className}>
      <div styleName="ad-slot">
        <DfpAd
          adtype={
            isSectionComponent
              ? lang === "en"
                ? "EnPalo_ROS_336x280_R1"
                : "News_336x280_R1"
              : lang === "en"
              ? "EnPalo_HP_300x250_R3"
              : "Home_336x280_R3"
          }
          collectionSlug={collectionSlug}
          slotId={adSlotId}
        />
      </div>
      {!isSectionComponent || (widgetUrl && String(widgetUrl).toLocaleLowerCase().includes("localsearch")) ? (
        <TagStorySearch className="tag-story" />
      ) : widgetUrl && !validURL(widgetUrl) && collectionsNames && collectionsNames.length ? (
        <SerialStoriesTab collectionNames={collectionsNames} />
      ) : (
        widgetUrl &&
        validURL(widgetUrl) && (
          <div styleName="widget-wrapper">
            <iframe
              title="six stories 1 ad with tag search "
              src={widgetUrl}
              styleName="widget-iframe"
              style={widgetHeight ? { height: `${widgetHeight}px` } : {}}
            ></iframe>
          </div>
        )
      )}
    </div>
  );
};

Organism3.propTypes = {
  className: string,
  isSectionComponent: bool,
  widgetUrl: string,
  widgetHeight: string,
  collectionSlug: string,
  adSlotId: string,
  lang: string,
};

export default Organism3;
